import React from "react";
import ServiceSpace from "../../components/dashboard/ServiceSpace";
import ErpAccessCard from "../../components/dashboard/ErpAccessCard";
import pricing from "../../assets/data/pricing.json";

function UserPlatformGRH() {
  return (
    <ServiceSpace
      serviceCode="grh"
      flow="management"
      flowPath="/platform-gest"
      title="Ressources humaines"
      lead="Le module ressources humaines de votre Gestion 360."
      offer="Dossiers des employés, contrats, présences et congés, suivis par nos équipes."
      price={Math.min(pricing.platformGRH.mensuel, pricing.platformGRH.annuel)}
      topContent={<ErpAccessCard />}
    />
  );
}

export default UserPlatformGRH;
